export const CurrentSlideIcon = () => (
    <svg id="icon-slide-current" xmlns="http://www.w3.org/2000/svg" className="h-2.5em w-2.5em stroke-white" viewBox="0 0 40 40" aria-hidden="true">
        <path d="m12.41,11l8.9,8.34c.38.36.38.96,0,1.31l-8.9,8.34" fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
        <line x1="27" y1="11" x2="27" y2="29" fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
    </svg>
);
